import { jsx as _jsx } from "react/jsx-runtime";
import iconLibrary from "./icon-library";
// This component is a proxy for all icon components in the icon library
// Instead of importing individual icon components, devs can import this component and pass an iconName prop
// <Icon iconName="Add"/> and NOT <Add />
export const Icon = ({ color = "primaryBlack", fontSize = "medium", iconName, testId, }) => {
    // Get the icon component from the icon library based on the iconName prop
    const TreezIcon = iconLibrary[iconName];
    return _jsx(TreezIcon, { fontSize: fontSize, color: color, testId: testId });
};
